<template>
  <div class="flex justify-center items-center flex-col h-[30rem]">
    <img :src="imgPath" alt="Blank" class="w-[224px] h-[224px]" />
    <span
      v-if="heading"
      class="w-[336px] text-black text-center font-sans text-lg not-italic font-bold leading-normal tracking-[-0.3px] mt-3"
    >
      {{ t(heading) }}
    </span>
    <span
      v-for="(text, index) in textArray"
      :key="index"
      class="text-black text-center font-sans text-[18px] not-italic font-normal leading-normal tracking-[-0.27px]"
      :class="{ 'pt-4': applyTextPadding }"
      :data-target="`${dataText}-text-${index}`"
    >
      {{ t(text) }}
    </span>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
  heading: {
    type: String,
    default: null,
  },
  textArray: {
    type: Array<string>,
    required: true,
  },
  imgPath: {
    type: String,
    required: true,
  },
  applyTextPadding: {
    type: Boolean,
    default: false,
  },
  dataText: {
    type: String,
    required: true,
  },
});
</script>
